import { setConfig } from "@xplus/utils/config";
import { version } from "./version";
import type { App, Plugin } from "vue";
import type { ComponentSize } from "@xplus/utils/types";
import type { InstallOptions } from "@xplus/utils/config";

const makeInstaller = (components: Plugin[] = []) => {
  const apps: App[] = [];

  const install = (app: App, opts: InstallOptions) => {
    const defaultInstallOpt: InstallOptions = {
      size: "" as ComponentSize,
      zIndex: 2000,
    };

    const option = Object.assign(defaultInstallOpt, opts);
    if (apps.includes(app)) return;
    apps.push(app);

    components.forEach((c) => {
      app.use(c);
    });

    // leave TODO: 国际化
    // if (option.locale) {
    //   const localeProvides = localeProviderMaker(opts.locale);
    //   app.provide(LocaleInjectionKey, localeProvides);
    // }

    app.config.globalProperties.$GPLUS = option;
    // app.provide() ? is this better? I think its not that flexible but worth implement
    setConfig(option);
  };

  return {
    version,
    install,
  };
};

export default makeInstaller;
